import type { MarketExceptionType } from '../../MarketExceptionTypes'
import { Common } from '../Common/Common'

export const DO: MarketExceptionType = {
  ...Common,
  hasNativeCreditCard: true,
  marketoSmsOptIn: true,
  signUpReCaptcha: true,
  showPasswordRequirements: true,
  signupPrivacyPolicy: {
    enabled: true,
    required: true,
  },
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: true,
    required: true,
  },
  creditCardProvidersSupported: ['MC', 'VI', 'AX', 'DI'],
  poboxRestricted: true,
  isPickupMarket: true,
  supportsStoreCredit: true,
  hasProductAvailability: true,
  bankName: 'WorldPay',
  skuPricingOverrides: ['36306'],
  allowSubscriptionPickup: true,
  skuAvailabilityShippingMethod: 'WillCall&location=Unicity DR',
  addressFormConfig: [
    { field: 'firstName', required: true },
    { field: 'lastName', required: true },
    { field: 'country', required: true },
    { field: 'empty', required: true },
    { field: 'address1', required: true },
    { field: 'address2', required: false },
    { field: 'city', required: true },
    { field: 'state', required: true },
  ],
  addressDisplayOrder: {
    line1: [{ field: 'firstName' }, { field: 'lastName' }],
    line2: [{ field: 'address1' }],
    line3: [{ field: 'address2' }],
    line4: [
      { field: 'city', addComma: true },
      { field: 'state', addComma: true },
      { field: 'country' },
    ],
  },
}
